import { Box } from "components/ui";
import React from "react";
import HeaderPrimary from "./HeaderPrimary";
import HeaderSecondary from "./HeaderSecondary";
import { useIsMobile } from "utils/hooks/useIsMobile";

type Props = {};

const HeaderMain = (props: Props) => {
	const isMobile = useIsMobile();
	return (
		<Box>
			<HeaderPrimary />
			{!isMobile && <HeaderSecondary />}
		</Box>
	);
};

export default React.memo(HeaderMain);
